<template>
  <v-container>
    <div>
      <div
        v-if="loading1"
        id="loadingDevQuebra"
        class="text-center"
        :style="styleObject"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error1"
        class="alert alert-danger"
      >
        {{ error1 }}
      </div>
      <div
        id="idDevolucaoQuebra"
      >
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <canvas
              id="myChartDevolucaoTotalQuebra"
            />
            <div
              v-if="enableQuebra"
              id="textoQuebraId"
              class="text-center"
            >
              QUEBRA
            </div>
          </v-col>
        </v-row>
        <v-row v-if="enableQuebra">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              id="valorQuebra"
              class="text-center"
            >
              VALOR TOTAL <span :style="styleFaturamento">{{ valorQuebra }}</span>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Comercial from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'

  export default {
    name: 'ShowMeta',
    emits: ['enableDevolucaoQuebra'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleFaturamento: {
        color: '#C62828',
      },
      loading1: false,
      error1: null,
      dados: [],
      vendedores: [],
      selectMes: [],
      selectAno: [],
      myChart: {},
      valorQuebra: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      enableQuebra: false,
      labelsQuebra: [],
      quebra: [],
    }),

    created () {
      eventEmit.$on('update-dados-form', this.handleUpdateDados)

      eventEmit.$on('enable-quebra', this.handleUpdateGrafico)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-form', this.handleUpdateDados)

      eventEmit.$off('enable-quebra', this.handleUpdateGrafico)
    },

    methods: {
      handleUpdateDados (selectMes, selectAno, vendedores) {
        this.vendedores = vendedores
        this.selectMes = selectMes
        this.selectAno = selectAno

        this.valorQuebra = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.enableQuebra = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        this.showDevolucaoQuebra()
      },

      handleUpdateGrafico (valorQuebra, labelsQuebraTotal, quantidadeQuebraTotal) {
        this.valorQuebra = valorQuebra

        const ctx = document.getElementById('myChartDevolucaoTotalQuebra').getContext('2d')

        this.myChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labelsQuebraTotal,
            datasets: [
              {
                label: 'Devolução',
                data: quantidadeQuebraTotal,
                backgroundColor: '#4780b8',
                order: 1,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  gridLines: {
                    display: true,
                  },
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
              xAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  display: false,
                  barPercentage: 0.2,
                },
              ],
            },
            legend: {
              display: false,
              position: 'right',
              labels: {
                fontSize: 10,
                generateLabels: function (chart) {
                  return [
                    {
                      text: chart.data.datasets[0].data[0].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                      fillStyle: '#4780b8',
                    },
                  ]
                },
              },
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                },
                title: (tooltipItem) => {
                  return labelsQuebraTotal[tooltipItem[0].index]
                },
              },
            },
          },
        })
      },

      async showDevolucaoQuebra () {
        this.loading1 = true
        this.error1 = false

        await Comercial.showTotalDevolucaoQuebra(this.selectMes, this.selectAno, this.vendedores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorQuebra = resposta.data.devolucao[0].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.labelsQuebra = resposta.data.labels

            this.quebra = resposta.data.devolucao
            this.enableQuebra = true

            const ctx = document.getElementById('myChartDevolucaoTotalQuebra').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Devolução',
                    data: resposta.data.devolucao,
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  yAxes: [
                    {
                      gridLines: {
                        display: true,
                      },
                      ticks: {
                        beginAtZero: true,
                      },
                    },
                  ],
                  xAxes: [
                    {
                      gridLines: {
                        display: false,
                      },
                      display: false,
                      barPercentage: 0.2,
                    },
                  ],
                },
                legend: {
                  display: false,
                  position: 'right',
                  labels: {
                    fontSize: 10,
                    generateLabels: function (chart) {
                      return [
                        {
                          text: chart.data.datasets[0].data[0].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                          fillStyle: '#4780b8',
                        },
                      ]
                    },
                  },
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há devoluções para os filtros selecionados') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)

            this.error1 = resposta.data.text
          } else if (resposta.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.error1 = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error1 = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading1 = false

          eventEmit.$emit('enable-devolucao-quebra', this.labelsQuebra, this.quebra, this.valorQuebra)
        })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #idDevolucaoQuebra {
      margin: 0 0 0 0
    }

    #myChartDevolucaoTotalQuebra {
      height: 248px !important;
      width: 321px !important;
    }

    #valorQuebra {
      margin: -1rem 0 0 -5rem;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width: 1380px)
  and (max-width: 1901px) {
    #myChartDevolucaoTotalQuebra {
      width: 262px !important;
      height: 303px !important;
      margin: 2rem 0 0 -2rem;
    }

    #valorQuebra {
      margin: -1rem 0 0 -8rem;
      font-size: 14px;
    }

    #textoQuebraId {
      margin: 0 0 0 -10rem !important
    }
  }

  @media screen
  and (min-width: 1902px) {
    #myChartDevolucaoTotalQuebra {
      width: 308px !important;
      height: 303px !important;
      margin: 2rem 0 0 -2rem;
    }
  }
</style>

<style lang="sass">
  #loadingDevQuebra
    margin: 5rem 0 0 -17rem

  #valorQuebra
    margin: -1rem 0 0 -5rem
    font-size: 14px

  #myChartDevolucaoTotalQuebra
    width: 230px !important
    height: 220px !important

  #idDevolucaoQuebra
    margin: 0 0 0 -12rem

  #textoQuebraId
    margin: 0 0 0 -5rem

  @media print
    #myChartDevolucaoTotalQuebra
      width: 180px !important
      height: 220px !important
      margin: 0 0 0 0rem

    #valorQuebra
      font-size: 12px !important
      margin: 0 0 0 -39rem !important

    #textoQuebraId
      margin: 0 0 0 -39rem !important
</style>
